export enum NotificationMessageType {
    UNBOARDING_OWNER = 'UNBOARDING_OWNER',
    UNBOARDING_RENTER = 'UNBOARDING_RENTER',
    YOU_NO_MORE_OWNER = 'YOU_NO_MORE_OWNER',
    TOURNAMENT_INTRO = 'TOURNAMENT_INTRO'
}